import React from 'react'
import cx from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import Button from '../Button'
import ValuationInput from '../ValuationInput'
import ContactRequestInput from '../ContactRequestInput'
import PriceDevelopment from '../../listings/components/PriceDevelopment'
import AnimateIn from '../AnimateIn'

const LeadQuestions = ({ data, isAnimated }) => {
  const isLeadSite = data.country.includes('LEAD')

  const textColor = isLeadSite ? 'text-charcoal-500' : 'text-blue-500'

  const paddingUnit = data.paddingUnit ? data.paddingUnit : 'px'
  const paddingTop =
    data.paddingTop !== null ? data.paddingTop + paddingUnit : null
  const paddingBottom =
    data.paddingBottom !== null ? data.paddingBottom + paddingUnit : null

  return (
    <AnimateIn disabled={!isAnimated} distance={0} opacityDuration={1000}>
      <div
        className="container flex flex-col items-center lg:items-start lg:flex-row"
        style={{ paddingTop, paddingBottom }}
      >
        <div className="py-12 border-b border-gray-400 lg:px-12 lg:w-1/2 lg:border-r lg:border-b-0">
          <div className="flex flex-col w-full max-w-sm mx-auto space-y-6">
            {data.priceWatchTitle ? (
              <h4
                className={cx(
                  'text-xl font-bold leading-tight text-center',
                  textColor,
                  data.priceWatchOption === 'V2'
                    ? 'lg:max-w-[260px] mx-auto'
                    : ''
                )}
              >
                {data.priceWatchTitle}
              </h4>
            ) : null}
            <PriceDevelopment colorOption={isLeadSite ? 'charcoal' : 'blue'} />
            {data.priceWatchDescription ? (
              <p
                className={cx(
                  'text-sm text-center text-gray-800',
                  data.priceWatchOption === 'V2'
                    ? 'lg:min-h-[40px] lg:max-w-[350px] mx-auto'
                    : ''
                )}
              >
                {data.priceWatchDescription}
              </p>
            ) : null}
            {data.priceWatchOption === 'V2' ? (
              <div className="w-full mx-auto !mt-[2.1rem] max-w-[300px]">
                <Button
                  buttonStyle={isLeadSite ? 'lime' : 'blue'}
                  buttonLabel={data.priceWatchV2ButtonLabel}
                  buttonLink={data.priceWatchV2ButtonLink}
                  className="w-full"
                />
              </div>
            ) : (
              <ValuationInput
                inputPlaceholder={data.priceWatchInputPlaceholder}
                buttonLabel={data.priceWatchSubmitText}
                className="w-full mx-auto space-y-4 max-w-[300px]"
                buttonClassName="w-full"
                buttonStyle={isLeadSite ? 'lime' : 'blue'}
              />
            )}
          </div>
        </div>
        <div className="px-6 py-12 lg:px-12 lg:w-1/2">
          <div className="flex flex-col w-full max-w-sm mx-auto space-y-6">
            {data.contactRequestTitle ? (
              <h4
                className={cx(
                  'text-xl font-bold leading-tight text-center',
                  textColor
                )}
              >
                {data.contactRequestTitle}
              </h4>
            ) : null}
            {data.realtors?.length > 0 ? (
              <div className="flex mx-auto -space-x-1.5 lg:-space-x-2">
                {data.realtors.map(({ gatsbyImageData, description }) => (
                  <GatsbyImage
                    key={gatsbyImageData.images.sources[0].srcSet}
                    className="w-12 h-12 rounded-full lg:w-15 lg:h-15 rounded-full-placeholder"
                    alt={description ? description : ''}
                    imgClassName="object-bottom rounded-full"
                    image={gatsbyImageData}
                  />
                ))}
              </div>
            ) : null}
            {data.contactRequestDescription ? (
              <p className="text-sm text-center text-gray-800">
                {data.contactRequestDescription}
              </p>
            ) : null}
            <ContactRequestInput
              className="w-full mx-auto space-y-4 max-w-[300px]"
              buttonLabel={data.contactRequestSubmitText}
              inputPlaceholder={data.contactRequestInputPlaceholder}
              buttonClassName="w-full"
              buttonStyle={isLeadSite ? 'lime' : 'blue'}
            />
            <div className="mx-auto">
              <Button
                buttonLabel={data.faqLinkText}
                buttonLink={data.faqLink}
                buttonStyle="link-underline"
                className="text-center"
              />
            </div>
          </div>
        </div>
      </div>
    </AnimateIn>
  )
}

export default LeadQuestions
